var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3646 9.86364C14.3646 12.1505 12.5151 14 10.2283 14L10.8487 12.9659M1.36462 5.13636C1.36462 2.84955 3.21417 1 5.50099 1L4.88053 2.03409",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68555 9.48543H6.346C6.71827 9.48543 7.01373 9.18407 7.01373 8.8177C7.01373 8.48089 6.71237 8.14998 6.346 8.14998H4.68555V9.48543ZM4.68555 9.48543H6.58827C7.00782 9.48543 7.35055 9.78089 7.35055 10.1532C7.35055 10.5195 7.00782 10.8209 6.58827 10.8209H4.68555V9.48543ZM5.74918 10.815V11.4768M5.74918 7.48816V8.14998",
    stroke: "#C9CBCD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54878 9.48548C9.54878 11.5005 7.91787 13.1314 5.90287 13.1314C3.88787 13.1314 2.25696 11.5005 2.25696 9.48548C2.25696 7.47048 3.88787 5.83957 5.90287 5.83957C5.99741 5.83957 6.08605 5.84548 6.1865 5.85139C7.97696 5.9873 9.40696 7.4173 9.54287 9.20775C9.54287 9.29639 9.54878 9.38502 9.54878 9.48548Z",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4783 5.55002C13.4783 7.56502 11.8474 9.19593 9.83243 9.19593H9.54289C9.47583 8.32807 9.10068 7.51278 8.48518 6.89728C7.86967 6.28178 7.05439 5.90663 6.18652 5.83957V5.55002C6.18652 3.53502 7.81743 1.90411 9.83243 1.90411C11.8474 1.90411 13.4783 3.53502 13.4783 5.55002Z",
    stroke: "#C9CBCD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coins-icon.c4dd9b497faa9e8af1b4e3985932b5b0.svg";
export { ForwardRef as ReactComponent };